/* ========================================
   HQ AUTO VAULT — GLOBAL SCRIPTS
   Vanilla JS only, accessible interactions
   ======================================== */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ========== FOCUS TRAP (shared modal helper) ========== */
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container) {
    var previouslyFocused = document.activeElement;
    function onKeydown(e) {
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', onKeydown);
    return function releaseFocus(restoreTo) {
      container.removeEventListener('keydown', onKeydown);
      var target = restoreTo || previouslyFocused;
      if (target && typeof target.focus === 'function') target.focus();
    };
  }

  /* ========== HEADER SCROLL STATE ========== */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('site-header--solid', window.scrollY > 2);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ========== MOBILE MENU ========== */
  var menuBtn = document.querySelector('[data-mobile-menu-open]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileMenuOverlay = document.querySelector('[data-mobile-menu-overlay]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');

  var releaseMenuFocus = null;

  function openMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.add('is-open');
      mobileMenuOverlay.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      releaseMenuFocus = trapFocus(mobileMenu);
      // Focus first link
      var firstLink = mobileMenu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
  }

  function closeMobileMenu() {
    if (mobileMenu && mobileMenuOverlay) {
      mobileMenu.classList.remove('is-open');
      mobileMenuOverlay.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (releaseMenuFocus) {
        releaseMenuFocus(menuBtn);
        releaseMenuFocus = null;
      } else if (menuBtn) {
        menuBtn.focus();
      }
    }
  }

  if (menuBtn) {
    menuBtn.addEventListener('click', openMobileMenu);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMobileMenu);
  }

  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  }

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  /* ========== ACCORDION ========== */
  var accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panel = this.nextElementSibling;
      var isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Close all other accordions in the same group
      var accordion = this.closest('[data-accordion]');
      if (accordion) {
        var allTriggers = accordion.querySelectorAll('[data-accordion-trigger]');
        allTriggers.forEach(function (t) {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            var p = t.nextElementSibling;
            if (p) p.setAttribute('aria-hidden', 'true');
          }
        });
      }

      // Toggle current
      this.setAttribute('aria-expanded', !isExpanded);
      if (panel) {
        panel.setAttribute('aria-hidden', isExpanded);
      }
    });
  });

  /* ========== GALLERY LIGHTBOX ========== */
  var galleryItems = document.querySelectorAll('[data-gallery-item]');
  var lightbox = document.querySelector('[data-lightbox]');
  var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
  var lightboxClose = lightbox ? lightbox.querySelector('[data-lightbox-close]') : null;
  var currentLightboxIndex = 0;
  var lightboxImages = [];

  var releaseLightboxFocus = null;

  function openLightbox(index) {
    if (!lightbox || !lightboxImg || lightboxImages.length === 0) return;
    currentLightboxIndex = index;
    lightboxImg.src = lightboxImages[currentLightboxIndex].src;
    lightboxImg.alt = lightboxImages[currentLightboxIndex].alt;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    releaseLightboxFocus = trapFocus(lightbox);
    if (lightboxClose) lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (releaseLightboxFocus) {
      releaseLightboxFocus();
      releaseLightboxFocus = null;
    }
  }

  function nextLightboxImage() {
    currentLightboxIndex = (currentLightboxIndex + 1) % lightboxImages.length;
    if (lightboxImg) {
      lightboxImg.src = lightboxImages[currentLightboxIndex].src;
      lightboxImg.alt = lightboxImages[currentLightboxIndex].alt;
    }
  }

  function prevLightboxImage() {
    currentLightboxIndex = (currentLightboxIndex - 1 + lightboxImages.length) % lightboxImages.length;
    if (lightboxImg) {
      lightboxImg.src = lightboxImages[currentLightboxIndex].src;
      lightboxImg.alt = lightboxImages[currentLightboxIndex].alt;
    }
  }

  galleryItems.forEach(function (item, index) {
    var img = item.querySelector('img');
    if (img) {
      lightboxImages.push({
        src: img.src.replace(/width=\d+/, 'width=1800'),
        alt: img.alt
      });
      item.addEventListener('click', function () {
        openLightbox(index);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(index);
        }
      });
    }
  });

  if (lightboxClose) {
    lightboxClose.addEventListener('click', closeLightbox);
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      closeLightbox();
    } else if (e.key === 'ArrowRight') {
      nextLightboxImage();
    } else if (e.key === 'ArrowLeft') {
      prevLightboxImage();
    }
  });

  // Touch swipe support
  var touchStartX = 0;
  var touchEndX = 0;
  if (lightbox) {
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) {
        nextLightboxImage();
      } else if (touchEndX - touchStartX > 50) {
        prevLightboxImage();
      }
    }, { passive: true });
  }

  /* ========== TESTIMONIAL CAROUSEL ========== */
  var carouselPrev = document.querySelector('[data-carousel-prev]');
  var carouselNext = document.querySelector('[data-carousel-next]');
  var testimonials = document.querySelectorAll('[data-testimonial]');
  var carouselDots = document.querySelectorAll('[data-carousel-dot]');
  var currentTestimonial = 0;

  function showTestimonial(index) {
    testimonials.forEach(function (t, i) {
      t.style.display = i === index ? 'block' : 'none';
    });
    carouselDots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
    currentTestimonial = index;
  }

  if (carouselNext) {
    carouselNext.addEventListener('click', function () {
      var next = (currentTestimonial + 1) % testimonials.length;
      showTestimonial(next);
    });
  }

  if (carouselPrev) {
    carouselPrev.addEventListener('click', function () {
      var prev = (currentTestimonial - 1 + testimonials.length) % testimonials.length;
      showTestimonial(prev);
    });
  }

  carouselDots.forEach(function (dot, index) {
    dot.addEventListener('click', function () {
      showTestimonial(index);
    });
  });

  if (testimonials.length > 0) {
    showTestimonial(0);
  }

  /* ========== REVEAL ON SCROLL ========== */
  if (!prefersReducedMotion) {
    var revealElements = document.querySelectorAll('[data-reveal]');
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealElements.forEach(function (el) {
      el.classList.add('reveal');
      revealObserver.observe(el);
    });
  } else {
    // Skip animations for users who prefer reduced motion
    var revealElements = document.querySelectorAll('[data-reveal]');
    revealElements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ========== GALLERY FILTERING ========== */
  var filterButtons = document.querySelectorAll('[data-filter]');
  var filterableItems = document.querySelectorAll('[data-filter-item]');

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var filter = this.getAttribute('data-filter');

      // Update active state
      filterButtons.forEach(function (btn) {
        btn.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // Filter items
      filterableItems.forEach(function (item) {
        var category = item.getAttribute('data-filter-item');
        if (filter === 'all' || category === filter) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  /* ========== SMOOTH SCROLL FOR ANCHOR LINKS ========== */
  if (!prefersReducedMotion) {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /* ========== FORM VALIDATION HELPERS ========== */
  var forms = document.querySelectorAll('[data-form]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var requiredFields = form.querySelectorAll('[required]');
      var hasErrors = false;

      requiredFields.forEach(function (field) {
        var errorEl = field.parentElement.querySelector('.form-error');
        if (!field.value.trim()) {
          hasErrors = true;
          if (!errorEl) {
            errorEl = document.createElement('div');
            errorEl.className = 'form-error';
            errorEl.textContent = 'This field is required.';
            field.parentElement.appendChild(errorEl);
          }
          field.setAttribute('aria-invalid', 'true');
        } else {
          if (errorEl) {
            errorEl.remove();
          }
          field.removeAttribute('aria-invalid');
        }
      });

      if (hasErrors) {
        e.preventDefault();
      }
    });
  });
})();
